export const PENDING_INVITE_ORDER_ID_KEY = "pendingInviteOrderId";

export function buildInviteLandingPath(orderId) {
  const normalized = String(orderId ?? "").trim();
  if (!normalized) {
    return null;
  }
  return `/invitar-pago?orderId=${encodeURIComponent(normalized)}`;
}

export function buildInviteCheckoutPath(orderId) {
  const normalized = String(orderId ?? "").trim();
  if (!normalized) {
    return null;
  }
  return `/checkout?orderId=${encodeURIComponent(normalized)}`;
}

export function buildLoginRedirectForCheckout(orderId) {
  const checkoutPath = buildInviteCheckoutPath(orderId);
  if (!checkoutPath) {
    return "/login";
  }
  return `/login?redirect=${encodeURIComponent(checkoutPath)}`;
}

/**
 * Normalizes legacy invite landing redirects to checkout after login.
 *
 * @param {string | null} path
 * @returns {string | null}
 */
export function normalizeInvitePaymentRedirect(path) {
  if (!path || !path.startsWith("/")) {
    return path;
  }

  const queryIndex = path.indexOf("?");
  const pathname = queryIndex === -1 ? path : path.slice(0, queryIndex);
  if (pathname !== "/invitar-pago") {
    return path;
  }

  const search = queryIndex === -1 ? "" : path.slice(queryIndex);
  const params = new URLSearchParams(search);
  const orderId = params.get("orderId")?.trim();
  if (!orderId) {
    return path;
  }

  return buildInviteCheckoutPath(orderId);
}

/**
 * @param {URLSearchParams | string | null | undefined} search
 * @returns {string | null}
 */
export function readInviteOrderId(search) {
  const params = search instanceof URLSearchParams
    ? search
    : new URLSearchParams(typeof search === "string" ? search : "");

  const fromQuery = params.get("orderId")?.trim();
  if (fromQuery) {
    return fromQuery;
  }

  const redirectTarget = params.get("redirect");
  if (!redirectTarget) {
    return null;
  }

  try {
    const redirectUrl = redirectTarget.startsWith("/")
      ? new URL(redirectTarget, "http://invite.local")
      : new URL(redirectTarget);
    const orderFromRedirect = redirectUrl.searchParams.get("orderId")?.trim();
    return orderFromRedirect || null;
  } catch {
    return null;
  }
}

export function persistPendingInviteOrderId(orderId) {
  const normalized = String(orderId ?? "").trim();
  if (!normalized) {
    return;
  }
  try {
    sessionStorage.setItem(PENDING_INVITE_ORDER_ID_KEY, normalized);
  } catch {
    /* ignore */
  }
}

export function consumePendingInviteOrderId() {
  try {
    const stored = sessionStorage.getItem(PENDING_INVITE_ORDER_ID_KEY)?.trim();
    if (stored) {
      sessionStorage.removeItem(PENDING_INVITE_ORDER_ID_KEY);
      return stored;
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function clearPendingInviteOrderId() {
  try {
    sessionStorage.removeItem(PENDING_INVITE_ORDER_ID_KEY);
  } catch {
    /* ignore */
  }
}
